/**
 * Badge tokenizado para project.status — colores Doc 18 §"Mapping a estados".
 *
 * - active     → official (verde)
 * - on_hold    → review (ámbar)
 * - draft      → ink-muted neutral
 * - closed     → superseded (gris)
 * - cancelled  → critical (rojo)
 */

import { useTranslation } from 'react-i18next'

import type { ProjectStatus } from '../../api/projects'

interface Props {
  status: ProjectStatus
  size?: 'sm' | 'md'
}

export function ProjectStatusBadge({ status, size = 'sm' }: Props) {
  const { t } = useTranslation('projects')
  const cls = STATUS_CLS[status]
  const sizing =
    size === 'sm'
      ? 'px-2 py-0.5 text-[10px]'
      : 'px-2.5 py-1 text-xs'
  return (
    <span
      className={`rounded-full ${sizing} font-medium uppercase tracking-wider ${cls}`}
    >
      {t(`status.${status}` as const)}
    </span>
  )
}

const STATUS_CLS: Record<ProjectStatus, string> = {
  active: 'bg-official-soft text-official',
  on_hold: 'bg-review-soft text-review',
  draft: 'bg-surface-muted text-ink-muted',
  closed: 'bg-surface-muted text-ink-subtle',
  cancelled: 'bg-critical-soft text-critical',
}
